<template>
  <div>

    <el-form :inline="true" :model="formInline" size="mini" class="user-search">
      <!--<el-form-item label="" prop="operatorId">
        <el-select size="mini"
                   clearable
                   @change="selectOperator"
                   filterable
                   v-model="formInline.operatorId"
                   placeholder="运营商"
        >
          <el-option label="全 部" value=""></el-option>
          <el-option v-for="item in operators"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item prop="operatorId">
        <el-cascader placeholder="运营商" :show-all-levels="false"
                     size="mini" filterable
                     ref="cascader"
                     :options="operatorsTree"
                     v-model="operatorIds"
                     :props="{checkStrictly: true,expandTrigger: 'hover'}"
                     @change="handChangeOperator"
                     clearable></el-cascader>
      </el-form-item>

    </el-form>

    <el-container>
      <el-main>
        <!--充电分析-->
        <el-row :gutter="44">
          <el-col :span="24">
            <div class="div_two div_margin">
              <!--<h3 class="h5_style">客流分析</h3>-->
              <!--<div class="st-gbox" style="height: 20vh">
                <div class="div_style_one div_Orange">
                  <div class="fontStyle_three">
                    <div class="fontStyle_one">当日充电订单</div>
                    <div class="fontStyle_two">13</div>
                  </div>
                </div>
                <div class="div_style_one div_Orange">
                  <div class="fontStyle_three">
                    <div class="fontStyle_one">当日充电订单</div>
                    <div class="fontStyle_two">12</div>
                  </div>
                </div>
              </div>-->
              <div class="st-gbox">
                <div class="cavasbox" id="id"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <!--<div :id="id" :class="className" :style="{height:height,width:width}"></div>-->
    <!--<div :id="id" :class="className" style="width: 100%;height: 100%;margin-left: 10px;margin-right: 10px;"></div>-->
  </div>
</template>

<script type="text/ecmascript-6">
  import echarts from 'echarts'
  import api from '@/module/dataCenter/api/customerAnalusis.js'
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import comApi from '@/common/api/commonApi.js'

  export default {
    data () {
      return {
        operatorsTree: [],
        operatorIds: [],
        chart: null,
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        xxData: [],
        // 请求数据参数
        formInline: {
          analyseYear: '',
          analyseMonth: '',
          operatorId: ''
        },
        customerFlowData: {
          xaxisData: [],
          yaxisData: {}
        },
        operators: [],
        startDatePicker: this.beginDate(),
        endDatePicker: this.processDate(),

      }
    },

    mounted () {
      this.initChart()
    },
    beforeUpdate: function () {
    },
    created () {
      this.getOperators()
      this.getOperatorsTree()
      this.getData(this.formInline)
    },
    methods: {
      //获取运营商树
      getOperatorsTree() {
        let params = JSON.stringify({});
        comApi.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        let param = new Object()
        param.operatorId = operatorId
        this.getData(JSON.stringify(param))
        this.$refs.cascader.dropDownVisible = false
      },
      selectOperator (val) {
        console.log(val)
        let param = new Object()
        param.operatorId = val
        //this.getChargeData(JSON.stringify(param));
        this.getData(JSON.stringify(param))
      },
      //查询按钮
      search () {
        this.getData(this.formInline)
      },
      getOperators () {
        commonApi.getOperators().then((res) => {
          this.operators = res
        })
      },
      beginDate () {
        const self = this
        return {
          disabledDate (time) {
            if (self.formInline.analyseYear) {  //如果结束时间不为空，则小于结束时间
              return new Date(self.formInline.analyseYear).getTime() < time.getTime()
            } else {
              // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
            }
          }
        }
      },
      processDate () {
        const self = this
        return {
          disabledDate (time) {
            if (self.formInline.analyMonth) {  //如果开始时间不为空，则结束时间大于开始时间
              return new Date(self.formInline.analyseMonth).getTime() > time.getTime()
            } else {
              // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
            }
          }
        }
      },
      getData (parameter) {
        console.log(parameter)
        this.loading = true
        api.getAnalyseData(parameter).then((res) => {
          if (res) {
            console.log('数据获取结果')
            console.log(res)
            this.customerFlowData = res
            console.log(res)
            this.initChart()
          }
          // 加载结束
          this.loading = false
        }).then(() => {
          this.formInline.id = null
        }).catch(error => {
          this.loading = false
        })
      },
      initChart () {
        let xzData = this.customerFlowData.xaxisData
        let totalNumData = this.customerFlowData.yaxisData.totalData
        let activeNumData = this.customerFlowData.yaxisData.activeData
        let growNumData = this.customerFlowData.yaxisData.growData
        let reduceNumData = this.customerFlowData.yaxisData.reduceData
        this.chart = echarts.init(document.getElementById('id'))
        this.chart.setOption({
          /*backgroundColor: '#344b58',*/
          /*title: {
            text: '客流分析',
            x: '20',
            top: '20',
            textStyle: {
              color: '#fff',
              fontSize: '22'
            },
            subtextStyle: {
              color: '#90979c',
              fontSize: '16'
            }
          },*/
          tooltip: {
            trigger: 'axis',
            /*axisPointer: {
              textStyle: {
                color: '#fff'
              }
            }*/
          },
          grid: {
            left: '5%',
            right: '5%',
            bottom: '3%',
            containLabel: true/*,
            borderWidth: 0,
            top: 100,
            textStyle: {
              color: '#fff'
            }*/
          },
          legend: {
            /*x: '5%',
            top: '5%',
            textStyle: {
              color: '#90979c'
            },*/
            data: ['客户总数', '新增客户数', '活跃客户数', '静默客户数']
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          //calculable: true,
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            /*axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              //show:true
            },*/
            data: xzData
          }],
          yAxis: [{
            /*type: 'value',*/
            /*yAxisIndex:1,*/
            /*splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            splitArea: {
              show: false
            }*/
          },
            {
              name: '数量/人',
              type: 'value',
            },
          ],
          /*dataZoom: [{
            show: true,
            height: 20,
            xAxisIndex: [
              0
            ],
            bottom: 40,
            start: 1,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            filterMode: 'empty',
            handleStyle: {
              color: '#d3dee5'
            },
            textStyle: {
              color: '#fff'
            },
            borderColor: '#90979c'
          }, {
            type: 'inside',
            show: true,
            height: 15,
            start: 1,
            end: 35
          }],*/
          series: [
            {
              name: '客户总数',
              type: 'line',
              stack: '总量',
              /*itemStyle: {
                normal: {
                  color: 'rgba(0,191,183,1)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },*/
              data: totalNumData
            },
            {
              name: '新增客户数',
              type: 'line',
              stack: '总量',
              /*barMaxWidth: 30,
              barGap: '10%',*/
              /*itemStyle: {
                normal: {
                  color: 'rgba(255,144,128,1)',
                  label: {
                    show: true,
                    textStyle: {
                      color: '#fff'
                    },
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },*/
              data: growNumData
            },
            {
              name: '活跃客户数',
              type: 'line',
              stack: '总量',
              /*itemStyle: {
                normal: {
                  color: 'rgba(252,230,48,1)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },*/
              data: activeNumData
            },
            /*{
             name: '静默客户数',
             type: 'line',
             stack: 'total',
             //symbolSize: 20,
             //symbol: 'circle',
             itemStyle: {
               normal: {
                 color: 'rgba(10,141,18,111)',
                 barBorderRadius: 0,
                 label: {
                   show: true,
                   position: 'top',
                   formatter(p) {
                     return p.value > 0 ? p.value : ''
                   }
                 }
               }
             },
             data: reduceNumData
           }*/
            {
              name: '静默客户数',
              type: 'line',
              stack: '总量',
              /*itemStyle: {
                normal: {
                  color: 'rgba(10,141,18,111)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter(p) {
                      return p.value > 0 ? p.value : ''
                    }
                  }
                }
              },*/
              data: reduceNumData
            },
          ]
        })
      }
    },
  }
</script>
<style scoped>
  .div_margin {
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .div_two {
    background-color: white;
  }

  .h5_style {
    text-align: left;
    margin: 0px 0px 10px 5px;
    padding-top: 15px;
  }

  .div_style_one {
    float: left;
    width: 18%;
    height: 60px;
    margin: 0px 10px 10px 0px
  }

  .div_Orange {
    background-color: #ffbc2e;
  }

  .div_red {
    background-color: #FF6640;
  }

  .div_bule {
    background-color: #409EFF;
  }

  .div_green {
    background-color: #43c26e;
  }

  .fontStyle_three {
    margin: 10px 20px 0px 20px;
  }

  .fontStyle_one {
    color: white;
    font-size: small;
  }

  .fontStyle_two {
    color: white;
    font-size: 20px;
    margin-top: 5px;
  }

  .fontStyle_four {
    font-size: small;
  }

  .fontStyle_five {
    font-size: 20px;
    margin-top: 5px;
  }

  .el-header {
    color: #C0C4CC;
    text-align: center;
    line-height: 20px;
  }

  .el-main {
    background-color: #f0f9eb;
    color: #333;
    text-align: center;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .chargestate {
    padding-top: -120px;
  }

  .st-gbox {
    /*background-color: #fff;*/
    margin-top: 20px;
    border-radius: 5px;
    height: 75vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  /*.el-row {*/
  /*margin-bottom: 4px;*/
  /*&:last-child {*/
  /*margin-bottom: 0;*/
  /*}*/
  /*}*/
  .grid-content {
    border-radius: 2px;
    min-height: 28px;
    line-height: 28px;
    text-align: left;
    font-size: small;
    color: #606266;
    padding-left: 10px;
  }

  /deep/ .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/customerAnalyse/customerFlow.vue